import React, { useContext, useEffect } from 'react'

import sendToNewRelic from 'services/new-relic'
import { verifyVersions } from 'utils/version'
import { IFichaCadastralCtx } from 'interfaces/fichaCadastral.interface'
import { AppConfigs, FichaCadastralCtx, UserInfoContext } from 'App'
import { IUserInfoCtx } from 'interfaces/userInfo.interface'
import { IAppCxt } from 'interfaces/app.interface'
import url from 'shared/functions/url'

import HomeKids from './homeKids'
import HomeAdult from './homeAdult'

const VERSION_CURRENT = '14.1.0'

const HomePosAbertura = () => {
  const { hsfc }: IFichaCadastralCtx = useContext<IFichaCadastralCtx>(FichaCadastralCtx)
  const { isUserMinor } = useContext<IUserInfoCtx>(UserInfoContext)
  const { version } = useContext<IAppCxt>(AppConfigs)

  const minorParam = url.queryParam().isMinor === 'true'
  const minorStorage = sessionStorage.getItem('isMinor') === 'true'

  const versionParam = url.queryParam().version
  const versionStorage = sessionStorage.getItem('version')

  const versionCurrent = version || versionStorage || versionParam
  const isMinorCurrent = isUserMinor || minorStorage || minorParam

  useEffect(() => {
    sendToNewRelic('VERIFY_VERSION', '[FUNCTION] - verifyVersionOrMinor', {
      versao: versionCurrent,
      ficha: hsfc,
      menor: isMinorCurrent,
      verifyVersions: verifyVersions(versionCurrent, VERSION_CURRENT),
      condition: isMinorCurrent && verifyVersions(versionCurrent, VERSION_CURRENT),
      url: document.location.href,
    })
  }, [hsfc, isMinorCurrent, versionCurrent])

  return isMinorCurrent && verifyVersions(versionCurrent, VERSION_CURRENT) ? (
    <HomeKids />
  ) : (
    <HomeAdult version={versionCurrent} />
  )
}

export default HomePosAbertura
